import { render, staticRenderFns } from "./SaleIcon.vue?vue&type=template&id=4fe0e4f8&"
import script from "./SaleIcon.vue?vue&type=script&lang=js&"
export * from "./SaleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports